import { Device, Document, RoadmapTasks, User } from "@models";
import { Alert, Link } from "@mui/material";
import { TemplateConfig } from "@types";
import { Fragment } from "react/jsx-runtime";
import { useDocEngine } from "src/hooks/useDocEngine";

interface DocWarningsProps {
  incompleteTemplates: string[];
  isSuggestion?: boolean;
  size?: "small" | "medium";
  customTitle?: string;
  deviceId: string;
  device: Device;
  documents: Document[];
  user: User;
  templatesConfig: TemplateConfig;
  tasks: RoadmapTasks;
}

export const DocWarnings = ({
  incompleteTemplates,
  isSuggestion = false,
  size = "medium",
  customTitle,
  deviceId,
  device,
  documents,
  user,
  templatesConfig,
  tasks,
}: DocWarningsProps) => {
  const docEngine = useDocEngine(deviceId);

  if (incompleteTemplates.length === 0) {
    return null;
  }

  const handleDocumentClick = async (templateKey: string) => {
    await docEngine.navigateToWizardOrQMS({
      templateKey,
      device,
      documents,
      user,
      templatesConfig,
      tasks,
    });
  };

  const title = isSuggestion ? "suggestion" : "document";
  const defaultTitle = `This ${title} was generated with`;

  return (
    <Alert
      severity="warning"
      sx={{
        fontSize: size === "small" ? "0.9rem" : "1rem",
        padding: ".2rem 1rem",
      }}
    >
      {customTitle || defaultTitle} limited context because the following
      document
      {incompleteTemplates.length > 1 ? "s are " : " is "} missing or
      incomplete:{" "}
      {incompleteTemplates.map((dep, index) => (
        <Fragment key={dep}>
          <Link
            key={dep}
            onClick={() => handleDocumentClick(dep)}
            className="cursor-pointer "
          >
            {templatesConfig?.[dep]?.defaultTitle}
          </Link>
          {index === incompleteTemplates.length - 1 ? ". " : ", "}
        </Fragment>
      ))}
    </Alert>
  );
};
